/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BarterState } from './barterState.model';
import { SubjectContactEntity } from './subjectContactEntity.model';
import { MonthYearUnit } from './monthYearUnit.model';
import { BarterNumberFormat } from './barterNumberFormat.model';
import { VersionType } from './versionType.model';


export interface Barter { 
    anyPassedGeometryOutOfDate?: boolean;
    anyPassedParcel?: boolean;
    anyReceivedGeometryOutOfDate?: boolean;
    anyReceivedParcel?: boolean;
    appendixNumber?: number;
    barterNumber?: number;
    barterNumberFormat?: BarterNumberFormat;
    barterNumberOfficial?: string;
    barterYear?: number;
    concernedSubject?: SubjectContactEntity;
    counterparty?: SubjectContactEntity;
    durationMonths?: number;
    durationMonthsUnit?: MonthYearUnit;
    durationToDate?: string;
    efficiencyFromDate?: string;
    endDate?: string;
    endType?: string;
    expirationDate?: string;
    furtherRentPossible?: boolean;
    groupId?: number;
    id?: number;
    incomingAmount?: number;
    incomingPayoutDate?: string;
    indefinite?: boolean;
    invalid?: boolean;
    invalidExplanation?: string;
    note?: string;
    noticePeriodMonths?: number;
    noticePeriodMonthsUnit?: string;
    outgoingAmount?: number;
    outgoingPayoutDate: string;
    paymentsFromEconomicYear?: boolean;
    previousVersionId?: number;
    resignDate?: string;
    reusedPreviousExpiration?: boolean;
    state?: BarterState;
    stateName?: string;
    sumConcernedAcreage?: number;
    toEconomicYear?: boolean;
    versionType?: VersionType;
}
export namespace Barter {
}


